import { Component, OnInit,ViewChild } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';
import {Router,NavigationEnd } from '@angular/router';
import { CommonServiceService } from '../services/common-service.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  username: string="";
  mailId:string="";
  pageURL:string
  signupCloseArray=[
    "/register","/","/signin","/reset-password","/admin"
  ]
  closeSidenav:boolean=true
  constructor(public dialog: MatDialog,
    private router: Router,
    private service: CommonServiceService) { this.router.events.subscribe((ev:any) => {
    if (ev instanceof NavigationEnd) { 
  this.checkRouteURl(ev.url);
    }
});}

  ngOnInit() {
    const merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
    if(merchantDetails) {
      this.username = merchantDetails.name;
      this.mailId = merchantDetails.email;
    }
    this.service.selectedUserName$.subscribe(name => {
      if(name && Object.values(name).length > 0) { this.username = name; }
    });
    this.service.selectedEmailId$.subscribe(email => { if(email && Object.values(email).length > 0) {this.mailId = email; }});
  }
  openDialog() {
    const dialogRef = this.dialog.open(DialogFromMenuExampleDialog, {restoreFocus: false});
    dialogRef.afterClosed().subscribe(() => this.menuTrigger.focus());
  }
  checkRouteURl(url){
    let a = url.split('?');
    this.pageURL =url
    if(this.signupCloseArray.includes(a[0])){
      this.closeSidenav = false 
    }else{
      this.closeSidenav = true 
    }
  }
  logout(){
    localStorage.clear();
    this.router.navigateByUrl('/signin');
  }
}


@Component({
  selector: 'dialog-from-menu-dialog',
  templateUrl: 'dialog-from-menu-example-dialog.html',
})
export class DialogFromMenuExampleDialog {}